export default __webpack_public_path__ + "static/media/mojitok_app_icon.a445d926.svg";